import { render, staticRenderFns } from "./HrGlossaryTip.vue?vue&type=template&id=68e76ba7&scoped=true"
import script from "./HrGlossaryTip.vue?vue&type=script&lang=js"
export * from "./HrGlossaryTip.vue?vue&type=script&lang=js"
import style0 from "./HrGlossaryTip.vue?vue&type=style&index=0&id=68e76ba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e76ba7",
  null
  
)

export default component.exports